module.exports = __webpack_public_path__ + "img/gestion-parasitaire-lauze.4473a58a.jpg";